export const SET_TASK = 'SET_TASK';
export const SET_ANSWER_INFO = 'SET_ANSWER_INFO';
export const SET_TASKS = 'SET_TASKS';
